import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import styles from './DialLabelComponent.module.scss';
import getColourForDialGroup, { DialGroup, getLabelForDialGroup } from '../../../services/DialGroupService';

interface DialLabelComponentProps {
    dialGroup: DialGroup,
}

const DialLabelComponent: FC<DialLabelComponentProps> = (props) => {
    const { dialGroup } = props;
    const dialColour = getColourForDialGroup(dialGroup);
    return (
        <Box
            sx={{ bgcolor: `${dialColour}33`, px: 1, borderRadius: 1 }}
            className={styles.DialLabelComponent}
            data-testid="DialLabelComponent"
        >
            <Typography
                sx={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '14px', lineHeight: '30px', color: dialColour }}
            >
                {getLabelForDialGroup(dialGroup)}
            </Typography>
        </Box>
    );
};

export default DialLabelComponent;
